import { render, staticRenderFns } from "./FabricacionView.vue?vue&type=template&id=06acc3ae"
import script from "./FabricacionView.vue?vue&type=script&lang=js"
export * from "./FabricacionView.vue?vue&type=script&lang=js"
import style0 from "./FabricacionView.vue?vue&type=style&index=0&id=06acc3ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports